import { useIsMutating } from "@tanstack/react-query";
import { cn } from "@/lib/utils";

/**
 * Global loading indicator that shows when React Query mutations are in progress.
 * Displays a subtle animated bar at the top of the viewport.
 */
export function GlobalMutationIndicator() {
  const isMutating = useIsMutating();

  if (isMutating === 0) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] pointer-events-none">
      <div className="h-1 w-full bg-primary/20 overflow-hidden">
        <div 
          className={cn(
            "h-full bg-primary rounded-full",
            "animate-[loading_1.5s_ease-in-out_infinite]"
          )}
          style={{
            width: "40%",
          }}
        />
      </div>
    </div>
  );
}
